

















































































import {Component, Inject} from "vue-property-decorator";
import {TerminalLocation, TerminalLocationWithStats, DateTime} from "../../modules/models";
import Api from "./Api";
import rd from "../../modules/vRoutedefs";
import CompanyUserRequired from "../CompanyRequired";
import {nonEmptyString} from "@/modules/utils";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";


@Component({
    components: {
        "at-ellips": Ellipsifier,
    }
})
export default class LocationOverview extends CompanyUserRequired {
    @Inject()
    api!: Api;

    // data:
    pLocations: TerminalLocationWithStats[] = [];
    showInactive = false;
    missingCompanyAccount = false;

    set locations(l: TerminalLocationWithStats[]) {
        this.pLocations = l;
    }
    get locations() {
        if(this.showInactive) {
            return this.pLocations;
        } else {
            return this.pLocations.filter((l) => !l.termloc.isShutdown);
        }
    }

    showCards = true; // False to show list of locations instead of cards.

    // methods:
    async loadLocations() {
        this.locations = await this.api.fetchLocations(this.company.orgNum);
        // If on mobile, and there are a lot of locations to display, switch to listview for a more condensed view of locations.
        if(this.mobileUi && this.locations.length > 15 ) {
            this.showCards = false;
        }
        //if(this.locations.length == 0) { Can be reactivated later if we get to the point where there are no old incomplete accounts.
            // Check if company account exists, location create is blocked if not
            const ca = await this.api.getCompanyAccount(this.company.orgNum);
            this.missingCompanyAccount = ca == null || ca.initStep < 4;
        //}
    }
    locationCreated(msg: string) {
        this.snackMsg = msg;
        this.loadLocations();
    }
    statusInfo(termloc: TerminalLocation): string {
        if(termloc.isShutdown) {
            const st = termloc.shutdownTime as DateTime;
            return `Inaktiv fra ${st.toLocalDate()}`;
        } else if(termloc.regWithoutTerminal) {
            return `Mobilregistrering aktivert`;
        }
        return "";
    }
    locationTo(termloc: TerminalLocation) {
        return rd.locations.location.paramPath(termloc.id);
    }
    get setupwizardTo() {
        return {name: rd.locations.setup.name};
    }

    get accountInitTo() {
        return {name: rd.company.init.name, query: {"init-orgnum": this.company.orgNum}};
    }

    hasAddressAndConstructorName(tl: TerminalLocation) {
        return nonEmptyString(tl.constructorName) != null && nonEmptyString(tl.address);
    }
    hasString(str: string | null) {
        return nonEmptyString(str);
    }

    snackMsg = "";
    get showSnack() {
        return this.snackMsg.length > 0;
    }
    set showSnack(v: boolean) {
        if(!v) {
            this.snackMsg = "";
        }
    }


    // hooks
    created() {
        this.loadLocations();
    }

}
